module.exports = __webpack_public_path__ + "media/stylesheets/images/logo-f4f5bd301ef062b9506ac7506d312b06.gif";